<template>
	<div>
		<span>
			{{ this.realContent }}
		</span>
	</div>
</template>
<script>

import {enumDef} from "@/common/enumDefs";

export default {
	computed: {
		realContent() {
			let draStatus = this.params.data[this.params.draStatusField];
			let draValue = this.params.data[this.params.colDef.field];

			return enumDef.ratingStatus.isRatingStatusActive(draStatus) && draValue > -1 ? draValue : "";
		}
	}
};
</script>
